import { render, staticRenderFns } from "./ArchitecturePanel.vue?vue&type=template&id=7d5df7c2&scoped=true"
import script from "./ArchitecturePanel.vue?vue&type=script&lang=js"
export * from "./ArchitecturePanel.vue?vue&type=script&lang=js"
import style0 from "./ArchitecturePanel.vue?vue&type=style&index=0&id=7d5df7c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d5df7c2",
  null
  
)

export default component.exports